import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/Layout';
import HomePage from '../components/HomePage';
import AboutPage from '../components/AboutPage';
import ServicesPage from '../components/ServicesPage';
import ContactPage from '../components/ContactPage';
import BlogsPage from '../components/BlogsPage';
import Blog1 from '../pages/Blog1';
import Blog2 from '../pages/Blog2';
import Blog3 from '../pages/Blog3';
import Blog4 from '../pages/Blog4';
import Blog5 from '../pages/Blog5';
import Blog6 from '../pages/Blog6';
import Blog7 from '../pages/Blog7';
import Blog8 from '../pages/Blog8';
import Blog9 from '../pages/Blog9';
import Blog10 from '../pages/Blog10';
import Blog11 from '../pages/Blog11';
import Blog12 from '../pages/Blog12';
import Blog13 from '../pages/Blog13';
import Blog14 from '../pages/Blog14';
import Blog15 from '../pages/Blog15';
import Blog16 from '../pages/Blog16';
import Blog17 from '../pages/Blog17';
import Blog18 from '../pages/Blog18';
import Blog19 from '../pages/Blog19';
import Blog20 from '../pages/Blog20';
import ChatPage from '../components/ChatPage';
import ChatLayout from '../components/ChatLayout';
import GaragePage from '../components/GaragePage';
import GarageChatPage from '../components/GarageChatPage';
import GloveboxPage from '../components/GloveboxPage';
import NotificationsPage from '../components/NotificationsPage';
import SettingsPage from '../components/SettingsPage';
import ShopDashboardPage from '../components/ShopDashboardPage';
import ShopCalendarPage from '../components/Partner/ShopCalendarPage';
import DiagnosticReportPage from '../components/DiagnosticReportPage';
import ShopEstimateAccessPage from '../components/ShopEstimateAccessPage';
import ShopReferralPage from '../components/ShopReferralPage';
// import OnboardingPage from '../components/OnboardingPage'; // #711: infographic intro disabled
import RepairPartnersPage from '../components/RepairPartnersPage';
import TermsOfUse from '../components/TermsOfUse';
import PrivacyPolicy from '../components/PrivacyPolicy';
import TesterPage from '../components/TesterPage';
import ExternalRedirect from '../components/ExternalRedirect';
import { partnerForgotPasswordUrl, partnerLoginUrl, partnerSignupUrl } from '../utils/siteHost';

export default function ConsumerApp() {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/home" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/blogs" element={<BlogsPage />} />
                <Route path="/maintenance/car-service-intervals" element={<Blog1 />} />
                <Route path="/driving-tips/improve-car-mileage" element={<Blog2 />} />
                <Route path="/safety/pre-road-trip-checklist" element={<Blog3 />} />
                <Route path="/off-road-prep/off-road-vehicle-checklist" element={<Blog4 />} />
                <Route path="/safety/car-dashboard-warning-lights" element={<Blog5 />} />
                <Route path="/buying-guide/used-car-inspection" element={<Blog6 />} />
                <Route path="/seasonal-care/winter-car-preparation" element={<Blog7 />} />
                <Route path="/electrical/car-battery-warning-signs" element={<Blog8 />} />
                <Route path="/emergency-help/jump-start-car" element={<Blog9 />} />
                <Route path="/maintenance/check-car-fluids" element={<Blog10 />} />
                <Route path="/troubleshooting/car-ac-not-cooling" element={<Blog11 />} />
                <Route path="/troubleshooting/car-overheating" element={<Blog12 />} />
                <Route path="/troubleshooting/car-shaking" element={<Blog13 />} />
                <Route path="/troubleshooting/car-slow-acceleration" element={<Blog14 />} />
                <Route path="/maintenance/car-maintenance-cost" element={<Blog15 />} />
                <Route path="/buying-guide/lease-vs-finance" element={<Blog16 />} />
                <Route path="/buying-guide/best-time-to-buy-car" element={<Blog17 />} />
                <Route path="/maintenance/brake-pad-replacement" element={<Blog18 />} />
                <Route path="/buying-guide/choose-car-tires" element={<Blog19 />} />
                <Route path="/safety/after-car-accident" element={<Blog20 />} />
                <Route path="/terms" element={<TermsOfUse />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
            </Route>
            <Route element={<ChatLayout />}>
                <Route path="/" element={<Navigate to="/chat" replace />} />
                <Route path="/chat" element={<ChatPage />} />
                <Route path="/garage" element={<GaragePage />} />
                <Route path="/garage/chat/:requestId" element={<GarageChatPage />} />
                <Route path="/glovebox" element={<GloveboxPage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/diagnostic-report/:reportId" element={<DiagnosticReportPage />} />
                <Route path="/shop" element={<ShopDashboardPage />} />
                <Route path="/shop/calendar" element={<ShopCalendarPage />} />
            </Route>

            {/* Partner portal moved to its own host. */}
            <Route path="/login" element={<ExternalRedirect to={partnerLoginUrl()} />} />
            <Route path="/signup" element={<ExternalRedirect to={partnerSignupUrl()} />} />
            <Route path="/forgot-password" element={<ExternalRedirect to={partnerForgotPasswordUrl()} />} />

            {/* Tokenized shop link — emailed from carfido.com, must keep working here. */}
            <Route path="/shop/estimate/:token" element={<ShopEstimateAccessPage />} />
            <Route path="/referral/:token" element={<ShopReferralPage />} />
            <Route path="/r/:referralCode" element={<ShopReferralPage />} />
            <Route path="/:shopSlug/referral" element={<ShopReferralPage />} />

            {/* #711: infographic intro disabled — old links redirect to chat */}
            {/* <Route path="/onboarding" element={<OnboardingPage />} /> */}
            <Route path="/onboarding" element={<Navigate to="/chat" replace />} />
            <Route path="/Partner" caseSensitive element={<Navigate to="/partner" replace />} />
            <Route path="/partners" caseSensitive element={<Navigate to="/partner" replace />} />
            <Route path="/Partners" caseSensitive element={<Navigate to="/partner" replace />} />
            <Route path="/partner" caseSensitive element={<RepairPartnersPage />} />
            <Route path="/partner/thanks" caseSensitive element={<RepairPartnersPage />} />
            <Route path="/signup/thanks" element={<RepairPartnersPage />} />
            <Route path="/signup/thanks.html" element={<RepairPartnersPage />} />
            <Route path="/tester" element={<TesterPage />} />
        </Routes>
    );
}
